import React, { Component } from 'react';
import SocialButton from './SocialButton.jsx';

export default class YoutubeButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageSrc: null
        };
    }

    render() {
        const { color, profileUrl } = this.props;
        return (
            <SocialButton
                style={this.props.style}
                imageSrc='https://s3.amazonaws.com/obsessvr-webstore-assets-public/youtube.svg'
                redirectUrl={profileUrl}
                color={color}
            />
        );
    }
}
